import { useEffect } from 'react';

export const useScrollClick = (
  numberOfSegments: number,
  firstSegment: number,
  mainScrollId?: string
) => {
  useEffect(() => {
    const mainScroll = mainScrollId ? document.getElementById(mainScrollId) : undefined;
    if (mainScroll) {
      const timelineWidth = mainScroll.scrollWidth;
      const availableWidth = mainScroll.clientWidth;
      const scrollRange = timelineWidth - availableWidth;

      const segmentWidth = timelineWidth / numberOfSegments;

      mainScroll.scrollLeft = segmentWidth * Math.min(firstSegment, scrollRange);
    }
  }, [numberOfSegments, firstSegment, mainScrollId]);

  const onClickRight = () => {
    const mainScroll = mainScrollId ? document.getElementById(mainScrollId) : undefined;
    if (mainScroll) {
      const timelineWidth = mainScroll.scrollWidth;
      const availableWidth = mainScroll.clientWidth;
      const scrollRange = timelineWidth - availableWidth;
      const scrollPosition = mainScroll.scrollLeft;

      const segmentWidth = timelineWidth / numberOfSegments;
      const currentSegment = Math.round(scrollPosition / segmentWidth);

      if (scrollPosition < scrollRange) {
        mainScroll.scrollLeft = segmentWidth * Math.min(currentSegment + 1, scrollRange);
      }
    }
  };

  const onClickLeft = () => {
    const mainScroll = mainScrollId ? document.getElementById(mainScrollId) : undefined;
    if (mainScroll) {
      const timelineWidth = mainScroll.scrollWidth;
      const scrollPosition = mainScroll.scrollLeft;

      const segmentWidth = timelineWidth / numberOfSegments;
      const currentSegment = Math.round(scrollPosition / segmentWidth);

      if (scrollPosition !== 0) {
        mainScroll.scrollLeft = segmentWidth * Math.max(currentSegment - 1, 0);
      }
    }
  };

  return { onClickRight, onClickLeft };
};
